<template>
  <div class="page notFound">
    <div class="left">
      <p class="title_lv1">{{$t('notFind_title')}}</p>
      <p class="title_lv3">{{$t('notFind_why')}}</p>
      <p class="title_lv2">{{$t('notFind_why1')}}<span style="margin-left: 5px;color: rgba(145,155,178,0.50);">{{$t('notFind_why11')}}</span></p>
      <p class="title_lv2">{{$t('notFind_why2')}}<span style="margin-left: 5px;color: rgba(145,155,178,0.50);">{{$t('notFind_why21')}}</span></p>
      <p class="title_lv3">{{$t('notFind_address')}}</p>
      <p class="link_to">
        <a href="/" style="margin-right: 5px;">{{$t('notFind_addressHome')}}</a>
        |<router-link to="/spot/btc_usdt">{{$t('notFind_addressTradeBB')}}</router-link>
      </p>
    </div>
    <div class="right">
      <img src="./img/not_find.jpg" class="not_find_icon">
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>

.notFound {
  margin: 0 auto;
  box-sizing: border-box;
  padding: 15% 270px 0;
  max-width: 1200px;
  border-radius: 30px;
  background: #fff;
  overflow: hidden;
  .left {
    float: left;
    max-width: 530px;
  }
  .left p {
    margin-bottom: 5px;
    line-height: 20px;
  }
  .left .title_lv1 {
    font-size: 20px;
    color: #202124;
    letter-spacing: 0;
  }
  .left .title_lv2 {
    font-size: 12px;
    color: #202124;
  }
  .left .title_lv3 {
    font-size: 12px;
    color: rgba(145, 155, 178, 0.5);
    margin-top: 30px;
  }
  .link_to {
    font-size: 12px;
    color: rgba(145, 155, 178, 0.5);
  }
  .link_to a {
    font-size: 12px;
    color: #202124;
  }
  .link_to a + a {
    margin: 0 5px;
  }
  .right {
    float: right;
  }
  .right .not_find_icon {
    width: 125px;
    height: 180px;
  }
  .title {
    margin-bottom: 30px;
    font-size: 20px;
    color: #202124;
    letter-spacing: 0;
    line-height: 20px;
  }
}

</style>
